






















































































import Modal from "../core/Modals/Modal.vue";
import Tabs from "../core/Tabs/Tabs.vue";
import Tab from "../core/Tabs/Tab.vue";
import { InterventionApi } from "../api/InterventionApi";
import InterventionModalDisplay from "./InterventionModalPartials/InterventionModalDisplay.vue";
import InterventionModalEdit from "./InterventionModalPartials/InterventionModalEdit.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { Intervention } from "../models/Intervention";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
import BonDePassageModal from "./BonDePassageModal.vue";
import History from "../core/History/History.vue";
import { Contact } from "../models/Contact";
import FacturationModalDisplay from "./InterventionModalPartials/FacturationModalDisplay.vue";
import FacturationModalEdit from "./InterventionModalPartials/FacturationModalEdit.vue";
import CheckboxInput from "../core/Forms/CheckboxInput.vue";
import { FacturationApi } from "../api/FacturationApi";
import { Employe } from "../models/Employe";
import InterventionModalPointageDisplay from "./InterventionModalPartials/InterventionModalPointageDisplay.vue";

export default {
    name: "InterventionModal",
    components: {
        InterventionModalPointageDisplay,
        CheckboxInput,
        FacturationModalEdit,
        FacturationModalDisplay,
        History,
        BonDePassageModal,
        EditionModal,
        InterventionModalEdit,
        InterventionModalDisplay,
        Modal,
        Tabs,
        Tab,
    },
    props: {
        interventionId: Number,
        isNew: Boolean,
        forceEditing: Boolean,
        defaultText: String,
        defaultClient: Contact,
        defaultEmploye: Employe,
    },
    data() {
        return {
            showModal: false,
            intervention: null,
            fetching: true,
            editing: false,
            InterventionApi: new InterventionApi(),
            FacturationApi: new FacturationApi(),
            UserApi: new UserApi(),
            editable: false,
            showBonDePassageModal: false,
        };
    },
    created() {
        var self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    watch: {
        interventionId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.InterventionApi.get(self.interventionId, {
                    include: "facturation,photos,history",
                }).then(function (res) {
                    self.intervention = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.intervention = new Intervention({});
                    this.intervention.titre = this.defaultText || "";
                    this.intervention.client = this.defaultClient;
                    if (this.defaultEmploye) {
                        this.intervention.employes = [this.defaultEmploye];
                    }
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.editing = false;
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveIntervention: function (): Promise<Intervention> {
            var self = this;

            if (self.intervention.facturation && !self.intervention.client) {
                swal("Veuillez renseigner un client", "", "error");
                return;
            }

            return self.InterventionApi.save(self.intervention).then(function (
                res
            ) {
                if (self.intervention.facturation) {
                    self.intervention.facturation.intervention_id = res.id;
                    self.intervention.facturation.copropriete_id =
                        res.client_id;
                    return self.FacturationApi.save(
                        self.intervention.facturation
                    ).then(function () {
                        self.$emit("data-saved", self.intervention);
                        return res;
                    });
                } else if (
                    self.intervention._facturation_to_delete &&
                    self.intervention._facturation_to_delete.id
                ) {
                    // Suppression implicite (case « Non facturation ») : pas
                    // de saisie, la corbeille reçoit une raison fixe.
                    return self.FacturationApi.delete(
                        self.intervention._facturation_to_delete.id,
                        "Intervention passée en non-facturation"
                    ).then(function () {
                        self.$emit("data-saved", self.intervention);
                        return res;
                    });
                } else {
                    self.$emit("data-saved", self.intervention);
                    return res;
                }
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
            this.intervention.nonFacturation = false;
        },
        duplicate: function (): void {
            this.intervention.id = null;
            this.intervention.frequence = Intervention.EFrequence.Ponctuel;
            this.creationModal();
            this.intervention.nonFacturation = true;
        },
        // Bon de passage
        sendBonDePassage(): void {
            this.showBonDePassageModal = true;
        },
        closeBonDePassageModal(): void {
            this.showBonDePassageModal = false;
        },
    },
};
